import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=68d000da&scoped=true&"
import script from "./ChartBar.vue?vue&type=script&lang=js&"
export * from "./ChartBar.vue?vue&type=script&lang=js&"
import style0 from "./ChartBar.vue?vue&type=style&index=0&id=68d000da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d000da",
  null
  
)

export default component.exports